// ** React Imports
import { ReactNode, useMemo } from 'react'

// ** MUI Imports
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { LocalizationProvider as DatePickersLocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'

// ** Intl Imports
import { IntlProvider } from 'react-intl'

// ** Effector Imports
import { useStore } from 'effector-react'

// ** Config Imports
import localizationConfig from 'src/configs/platform-localizations'

// ** Source code Imports
import globalStore from 'src/state-manager/global'

type Props = {
  children: ReactNode
}

const LocalizationProvider = ({ children }: Props) => {
  const { language } = useStore(globalStore.locale)

  const languageMessages = useMemo(() => {
    const currentLanguage = localizationConfig.find(({ value }) => value === language)?.options

    return currentLanguage || localizationConfig[0]?.options
  }, [language])

  return (
    <DatePickersLocalizationProvider adapterLocale={language} dateAdapter={AdapterDayjs}>
      <IntlProvider messages={languageMessages} locale={language} defaultLocale={language}>
        {children}
      </IntlProvider>
    </DatePickersLocalizationProvider>
  )
}

export { LocalizationProvider }
